import {Sequence} from 'components/Sequence';
import {VisibilityOptions} from 'components/VisibilityOptions';
import * as vo from 'components/VisibilityOptions';
import {StrandOfDoubleStranded} from 'constants/MolbioConstants';
import {DEFAULT_TYPE} from 'molbio/maps/PrimersViewConstants';
import Type from 'molbio/maps/Type';
import SequencePrimer from 'molbio/primers/backbone/SequencePrimer';
import {getModificationsForPrimerDisplay} from 'molbio/primers/PrimerUtil';
import * as sequtil from 'molbio/SeqUtil';

export function getSlicePrimers(
  sequence: Sequence,
  sliceStart: number,
  sliceEnd: number,
  strand?: StrandOfDoubleStranded
): Array<SequencePrimer> {
  return sequence
    .sequencePrimers()
    .filter(
      (primer) =>
        sequtil.isRangeOverlap(primer.start(), primer.end(), sliceStart, sliceEnd) &&
        (strand == null || primer.strand() === strand)
    );
}

export function getSliceHasAnyPrimerMods(sequence: Sequence, sliceStart: number, sliceEnd: number): boolean {
  return getSlicePrimers(sequence, sliceStart, sliceEnd).some(
    (primer: SequencePrimer) =>
      getModificationsForPrimerDisplay(primer.modifiedNucleotides(), primer.nucleotideType()).length > 0
  );
}

export function getPrimerBasesVisible(visibilityOptions: VisibilityOptions): boolean {
  return visibilityOptions.getOption(vo.PRIMER_BASES.name)?.get('visible') ?? false;
}

export function getPrimerType(visibilityOptions: VisibilityOptions, residuesType: Type): Type {
  return getPrimerBasesVisible(visibilityOptions) ? residuesType : DEFAULT_TYPE;
}
